import { BaseEntity } from 'yt-ng-framework';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
export class DokumentView extends BaseEntity{
    constructor(){
        super();
    }

    BrojDokumenta: string;
    Datum: NgbDate;
    Komitent: string;
    KomitentS: string;
    PodVrstaDokumentaStavka: string;
    UkupnoIzlaz: number;
    UkupnoUlaz: number;

    Deserialize(input: any){
        this.ID = input.ID;
        this.BrojDokumenta = input.BrojDokumenta;
        this.Datum = input.Datum;
        this.Komitent = input.Komitent;
        this.KomitentS = input.KomitentS;
        this.PodVrstaDokumentaStavka = input.PodVrstaDokumentaStavka;
        this.UkupnoIzlaz = input.UkupnoIzlaz;
        this.UkupnoUlaz = input.UkupnoUlaz;

        return this;
    }

    Serialize(input: DokumentView){
        return input;
    }
}